import { useAppSettings } from 'components/shared/SettingsProvider'

const LocationLabel = ({ locations, plan, editLocation }) => {
  const { enableReservationsByDay } = useAppSettings()

  if (editLocation && !plan) {
    return enableReservationsByDay ? 'Select a Location' : 'Select a Preferred Location'
  }

  if (locations.length === 1) {
    return 'Location Open Dates'
  }

  return enableReservationsByDay ? 'Location' : 'Preferred Location'
}

export default LocationLabel
